// EP-73 — AI Feature Coach (the floating bubble). `features.<id>` are the
// short per-node labels the STATIC fallback composes with the generic
// `static.*` template (the LLM path supplies its own rich text).
export default {
  bubble: {
    pill: 'Tip',
    heading: 'Quick win',
    why_label: 'Why this matters',
    steps_label: 'Steps',
    time_estimate: '~{{minutes}} min',
    resume_cta: 'Continue',
    discover_cta: 'Show me how',
    assets_label: 'Ready-made assets',
    download_asset: 'Download',
    dismiss: 'Dismiss',
    snooze: 'Later',
    done: 'Done',
  },
  static: {
    title: 'Set up {{feature}}',
    why: 'Finishing this helps you get more out of FlowRent.',
    step: 'Open {{feature}} and follow the on-screen steps.',
  },
  features: {
    property_created: 'your first property',
    unit_created: 'units',
    customer_created: 'a customer',
    lease_created: 'a lease',
    esign_link_sent: 'the e-sign link',
    lease_signed: 'lease signing',
    meter_added: 'a meter',
    meter_reading_recorded: 'meter readings',
    caf_configured: 'common area fees',
    invoice_created: 'an invoice',
    invoice_sent: 'sending the invoice',
    payment_recorded: 'a payment',
    report_viewed: 'reports',
    report_exported: 'a report export',
    maintenance_created: 'a maintenance request',
    maintenance_resolved: 'resolving maintenance',
    equipment_created: 'equipment',
    work_order_created: 'a work order',
    vehicle_added: 'a parking vehicle',
    parcel_scanned: 'parcel scanning',
    parcel_assigned: 'assigning a parcel',
    timesheet_logged: 'a timesheet entry',
    expense_created: 'an expense',
    bank_statement_uploaded: 'bank reconciliation',
    gl_account_setup: 'your chart of accounts',
    late_fee_policy_set: 'a late-fee policy',
    etax_issued: 'an e-Tax invoice',
    liff_published: 'your LINE mini-app',
    rich_menu_set: 'the LINE rich menu',
    microsite_published: 'your property microsite',
    announcement_published: 'an announcement',
    line_oa_configured: 'your LINE Official Account',
    template_customized: 'your document templates',
  },
} as const
